// src/components/layout/Footer.jsx
import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";


// import PrivacyPolicy from './components/Privacy/PrivacyPolicy';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div>
          <h3>About Us</h3>
          <p>
            Larch Technologies delivers innovative enterprise solutions that
            transform businesses and drive growth through cutting-edge technology.
          </p>
        </div>

        <div>
          <h3>Quick Links</h3>
          <ul className="quick-links">
             <li><Link to="/">Home</Link></li> 
             <li><Link to="/about">About</Link></li>
            <li><a href="#mes-system">Services</a></li>
            <li><a href="#manufacturing-traceability">Industries</a></li>
            <li><Link to="/Contactus">Contact</Link></li>
          </ul>
        </div>

        <div className="products">
          <h3>Products</h3>
          <ul>
            <li><a href="#">Cloud ERP</a></li>
            <li><a href="#">Traceability Tool</a></li>
            <li><a href="#">MES Software</a></li>
            <li><a href="#">Quality Inspection Tool</a></li>
            <li><a href="#">Mould and Tooling</a></li>
            <li><a href="#">Online Production Monitoring</a></li>
            <li><a href="#">IoT</a></li>
            <li><a href="#">AI and Automation</a></li>
            <li><a href="#">ERP</a></li>
          </ul>
        </div>

        <div>
          <h3>Follow Us</h3>
          <div className="social">
            <a href="https://www.linkedin.com/company/larcherp/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin-in" />
            </a>
            <a href="https://www.instagram.com/larch_technologies?utm_source=qr&igsh=MmoxZmcxODkxeTkz" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram" />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div>© 2025 Larch Technologies. All rights reserved.</div>
        <span>•</span>
        <div className="policy-links">
        
         <Link to="/PrivacyPolicy" >
                    Privacy Policy
                  </Link>
          <span>•</span>
          <Link to="/Terms" >
                   Terms &amp; Conditions
                  </Link>
         
        </div>
      </div>
    </footer>
  );
};

export default Footer;
